import { useState } from 'react';
import { raiseErrorToast } from '@fiverr-private/machine_translation';
import { translateReview } from '../../../../services/translateReview';
import { useReviewsContext } from '../../context/ReviewsContext/ReviewsContext';

const useTranslation = (originalText, sourceLanguage) => {
    const [isLoading, setLoading] = useState(false);
    const [translation, setTranslation] = useState();
    const [text, setText] = useState(originalText);
    const [isTranslatedText, setTranslatedText] = useState(false);
    const { translationUrl } = useReviewsContext();

    const toggleTranslation = async (sourceInfo) => {
        if (isTranslatedText) {
            setText(originalText);
            return setTranslatedText(false);
        }

        if (translation) {
            setText(translation);
            return setTranslatedText(true);
        }

        try {
            setLoading(true);
            const translatedReview = await translateReview({
                reviewText: originalText,
                sourceLanguage,
                sourceInfo,
                translationUrl,
            });
            setLoading(false);
            setTranslatedText(true);
            setTranslation(translatedReview);
            setText(translatedReview);
        } catch (error) {
            setLoading(false);
            raiseErrorToast();
        }
    };

    return {
        translationConfig: {
            isTranslatedText,
            isLoading,
            toggleTranslation,
        },
        text,
    };
};

export default useTranslation;
